import Cookies from 'js-cookie';

const url=process.env.REACT_APP_ENV==="production"?"https://nuecruit.nuearcus.com":process.env.REACT_APP_API_URL
 


async function ReceiveQuestionsMultiDomain(roleName, domainNames, experience) {
    try {
        // Join domain names with comma
        const domainsParam = Array.isArray(domainNames) 
            ? domainNames.join(',') 
            : domainNames;
        
        const response = await fetch(
            `${url}/api/ai/pyschotest/fetchquestionsmultidomain?userid=${Cookies.get('id')}&role_name=${encodeURIComponent(roleName)}&domain_names=${encodeURIComponent(domainsParam)}&experience=${encodeURIComponent(experience)}`,
            { method: 'GET' }
        );
        
        if (response.ok) {
            const data = await response.json();
            console.log('Multi-domain questions:', data);
            return data;
        }
        return { success: false, message: 'Issue with response!' };
    }
    catch (err) {
        console.error('Network error:', err);
        return { success: false, message: `Network error ${err}` };
    }
}


async function ReceiveQuestions(roleID,domainID){

      //  console.log('ids',roleID,domainID)
   
   try{
      const response=await fetch(`${url}/api/ai/pyschotest/fetchquestions?userid=${Cookies.get('id')}&roleId=${roleID}&domainId=${domainID}`,{method:'GET'});
      if(response.ok)
      {
         const data=await response.json();
         console.log('qa',data);
         return data;
      }
       return `Issue with reponse!`
   }
   catch(err)
   {
      return `Network error ${err}`
   }
}

async function TestCompletionCheck(){

   try{
      const response=await fetch(`${url}/api/ai/pyschotest/testCompletionCheck?userid=${Cookies.get('id')}`,{method:'GET'});
      if(response.ok)
      {
         const data=await response.json();
         return data;
      }
       return `Issue with reponse!`
   }
   catch(err)
   {
      return `Network error ${err}`
   }
}



async function ReceiveTestScore(userid){

   try{
      const response=await fetch(`${url}/api/ai/pyschotest/overalltestscore?userid=${userid}`,{method:'GET',
         headers:{'Content-Type':'application/json'}});

      if(response.ok)
      {
         const data=await response.json();
         // console.log("score",data);
         return data;
      }
       return `Issue with score reponse!`
   }
   catch(err)
   {
      return `Network error ${err}`
   }
}

async function ReceiveScore(data){

   const body=data;
   try{
      const response=await fetch(`${url}/api/ai/pyschotest/scoreBasedLLM`,{method:'POST',
         headers:{'Content-Type':'application/json'},
         body:JSON.stringify(body)});
      if(response.ok)
      {
         const data=await response.json();
         // console.log("score",data);
         return data;
      }
       return `Issue with score reponse!`
   }
   catch(err)
   {
      return `Network error ${err}`
   }
}

async function SubmitAnswer(data)
{
   try{
      const response=await fetch(`${url}/api/ai/pyschotest/submitanswer`,{body:JSON.stringify(data),method:'POST',headers:{'Content-Type':'application/json'}});
      if(response.ok)
         {
             const data=await response.json();
             console.log('submitanswer',data);
             return data;
         }
   }
   catch(error)
   {
      console.log("error",error);
       return error;
   }
}

export {ReceiveQuestions,ReceiveScore,SubmitAnswer,ReceiveTestScore,TestCompletionCheck,ReceiveQuestionsMultiDomain }